import { useMemo } from 'react';
import { Box, Flex, Text } from '@optiaxiom/react';

import { getEventMetadata } from '../constants';

type EventInformationProps = {
  eventType: string;
};

export function EventInformation({ eventType }: EventInformationProps) {
  const eventMetadata = useMemo(() => getEventMetadata(eventType), [eventType]);

  if (eventMetadata.length === 0) return null;

  return (
    <Box borderColor="border.secondary" border="1" bg="bg.secondary" p="12" rounded="md">
      <Flex flexDirection="column" gap="4" mb="8">
        <Text fontSize="md" fontWeight="600">
          Event Metadata
        </Text>
        <Text fontSize="sm" color="fg.secondary">
          This event will include the following information:
        </Text>
      </Flex>
      <Flex flexDirection="column" gap="8">
        {eventMetadata.map(field => (
          <Flex key={field.name} flexDirection="column" gap="2">
            <Text fontSize="md" fontWeight="600" color="fg.default">
              {field.name}:
            </Text>
            <Flex flexDirection="column" gap="2" pl="16">
              {field.properties.map(prop => (
                <Text key={prop} fontSize="md" color="fg.secondary">
                  • {prop}
                </Text>
              ))}
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
}
